import { AlignmentType } from 'docx'
import {
  createParagraphWithCenter,
  DocxException,
  createEmptyLine,
  createPageBreak,
} from '../docxFunctions'
import { createNumberedSectionHeading } from '@/components/reportPresentation/presentationSectionHeading'
import { createRefTable } from '@/components/reportPresentation/allTables/createRefTable'
import { createRefPricingFootnoteBlocks } from '@/components/reportPresentation/refPricingDocx'
import { createAgenciesTable } from '../allTables/createAgenciesTable'

export function createTwoChapter(reference, mnn, about, agencies) {
  try {
    return [
      createNumberedSectionHeading(2, 'МЕЖДУНАРОДНЫЙ ОПЫТ', {
        alignment: AlignmentType.LEFT,
      }),
      createEmptyLine(),
      createParagraphWithCenter(
        `Сравнение предлагаемой к регистрации цены в РФ и`,
        {
          size: 28,
          bold: true,
        },
        null
      ),
      createParagraphWithCenter(
        `зарегистрированной минимальной цены в референтных странах`,
        {
          size: 28,
          bold: true,
        },
        null
      ),
      createRefTable(reference?.pricing, mnn),
      ...createRefPricingFootnoteBlocks(reference),
      createPageBreak(),
      createParagraphWithCenter(
        `Сведения о рекомендациях зарубежных агентств по оценке медицинских `,
        {
          size: 28,
          bold: true,
        },
        null
      ),
      createParagraphWithCenter(
        `технологий о целесообразности государственного финансирования в `,
        {
          size: 28,
          bold: true,
        },
        null
      ),
      createParagraphWithCenter(
        `иностранном государстве предлагаемого лекарственного препарата `,
        {
          size: 28,
          bold: true,
        },
        null
      ),
      createEmptyLine(),
      createAgenciesTable(about, agencies),
    ]
  } catch (err) {
    throw new DocxException(1, err.message)
  }
}
